import React, { useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

export const Numbers = () => {
  const [state, setState] = useState({
    turnover: 1,
    workforce: 1,
    states: 1,
    cities: 1,
  });
  return (
    <>
      <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
        {({ isVisible }) => (
          <div className="numberbanner">
            <div className="container">
              <div className="web-container">
                <div className="count">
                  <div className="App">
                    <div className="countnum">
                      {/* {isVisible ? (
                        <CountUp
                          start={state.workforce === 1 ? 1 : 2}
                          end={2}
                          duration={2}
                          onEnd={() => setState({ workforce: 2 })}
                        />
                      ) : (
                        <CountUp start={1} end={2} duration={0} />
                      )}{" "} */}

                     3.2 GW
                      <div className="labelcont">
                        ANNUAL MANUFACTURING CAPACITY OF SOLAR CELLS
                      </div>
                    </div>
                  </div>

                  <div className="App">
                    <div className="countnum">
                      5.1 GW
                      <div className="labelcont">
                        MANUFACTURING CAPACITY OF SOLAR MODULES
                      </div>
                    </div>
                  </div>

                  <div className="App">
                    <div className="countnum">
                      {/* {isVisible ? (
                        <CountUp
                          start={state.workforce === 1 ? 1 : 0.2}
                          end={6.4} 
                          duration={2}
                          onEnd={() => setState({ workforce: 1 })}
                        />
                      ) : (
                        <CountUp start={1} end={6.4} duration={0} />
                      )}{" "} */}
                     6 GW
                      <div className="labelcont">
                        MODULE LINE UNDER CONSTRUCTION <span  style={{ fontSize: "23px" }}>*</span>
                      </div>
                    </div>
                  </div>
                  <div className="App">
                    <div className="countnum">
                      {/* {isVisible ? (
                        <CountUp
                          start={state.workforce === 1 ? 1 : 1}
                          end={6}
                          duration={2}
                          onEnd={() => setState({ workforce: 1 })}
                        />
                      ) : (
                        <CountUp start={1} end={6} duration={0} />
                      )}{" "} */}
                     6.8 GW
                      <div className="labelcont">
                        CELL LINE UNDER CONSTRUCTION <span  style={{ fontSize: "23px" }}>*</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span className="numberDisclaimer">
             Disclaimer: *By FY 2028
            </span>
          </div>
        )}
      </VisibilitySensor>
    </>
  );
};